<template>
  <div style="padding-bottom: 6rem;">
    <header>
      <h1>API {{ dadosApiCatalogo.nome }}</h1>
    </header>
    <section class="principal">
      <Menu @alterar-componente="alterarExibicao" :dados-api-catalogo="dadosApiCatalogo" :dados-api-menu="dadosApiMenu" :grupo="grupo" />
      <Especificacoes v-if="exibir['Especificacoes']" :dados-api-catalogo="getDadosApiCatalogo()" :grupo="grupo" :nome="nome" />
      <Documentacao v-if="exibir['Documentacao']" :key="idServicoApiMenu" :grupo="grupo" :nome="nome" :id-servico-api="idServicoApiMenu" />
      <Historico v-if="exibir['Historico']" :dados-api-catalogo="dadosApiCatalogo"/>

    </section>
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
        <!-- <div class="spinner-border spinner-border-2"></div> -->
      </div>
    </div>
    <button class="btn-chat" :style="{ top: `${posY}px` }" @click="abrirChat" v-if="exibiChat && !chatAberto">
    </button>
  </div>
</template>

<script>
import axios from "axios";
import Menu from './Menu.vue';
import Especificacoes from './Especificacoes.vue';
import Documentacao from './Documentacao.vue';
import Historico from "./Historico.vue";

export default {
  name: 'Template-Principal',
  components: {
    Menu,
    Especificacoes,
    Documentacao,
    Historico
  },
  data() {
    return {
      exibiChat: false,
      chatAberto: false,
      chatWindow: null,
      posY: 150,
      idServicoApiMenu: '',
      dadosApiCatalogo: {},
      dadosApiMenu: [],
      exibir: {
        Especificacoes: true,
        Documentacao: false
      },
      grupo: '',
      nome: '',
      segmentacao: '',
      portal: ''
    };
  },
  mounted() {
    this.grupo = this.$route.params.grupo;
    this.nome = this.$route.params.nome;
    this.segmentacao = this.$route.params.segmentacao != 'portal-sistemas' ? this.$route.params.segmentacao : undefined;
    this.portal = this.$route.params.segmentacao === 'portal-sistemas' ? 'portal-sistemas' : 'operadora';

    this.carregarDados();

    if (window.parent) {
      window.parent.addEventListener("scroll", this.onParentScroll);
    }
  },

  methods: {
    
    alterarExibicao(nomeDoComponente, idServicoApi) {
      this.idServicoApiMenu = idServicoApi;
      Object.keys(this.exibir).forEach(key => {
        this.exibir[key] = false;
      });
      this.exibir[nomeDoComponente] = true;
    },

    async validarChat(api) {
      if (api == "venda-automovel") { 
        this.exibiChat = true; 
      }
    },

   
    async carregarDados() {
      if (!this.grupo || !this.nome) {
        return;
      }

      try {
        
        const parametros = `${this.grupo}-${this.nome}`;

        this.validarChat(parametros);

        const urlCompletaApiCatalogo = `/massificados/corporativo/gerenciador-parceiros/portal-api/${this.portal}/consultar-catalogo/${encodeURIComponent(parametros)}`;
        const urlCompletaApiMenu = `/massificados/corporativo/gerenciador-parceiros/portal-api/consultar-menu/${encodeURIComponent(parametros)}`;

        const responseCatalogo = await axios.get(urlCompletaApiCatalogo);
        this.dadosApiCatalogo = responseCatalogo.data;


        const responseMenu = await axios.get(urlCompletaApiMenu);
        this.dadosApiMenu = responseMenu.data;

      } catch (error) {
      }
    },

    getDadosApiCatalogo() {
      return this.dadosApiCatalogo;
    },

    // scroll
    onParentScroll() {
      const scrollTop = window.parent.scrollY || window.parent.document.documentElement.scrollTop
      this.posY = 150 + scrollTop
    },

    abrirChat() {
      // const basePath = '/massificados/corporativo/gerenciador-parceiros-ui'
      // const url = `${window.location.origin}${basePath}/#/chat`
      const url = `${window.location.origin}${process.env.BASE_URL}#/chat`

      const width = 400
      const height = 600
      const right = 50
      const top = 250

      const left = window.screen.availWidth - width - right

      this.chatWindow = window.open(
        url,
        'ChatWindow',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,location=no,status=no,toolbar=no`
      )

      this.chatAberto = true

      const checker = setInterval(() => {
        if (this.chatWindow.closed) {
          clearInterval(checker)
          this.chatAberto = false
        }
      }, 500)
    }
  },


  beforeDestroy() {
    // scroll
    if (window.parent) {
      window.parent.removeEventListener("scroll", this.onParentScroll)
    }
  },
  watch: {
    grupo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.carregarDados();
      }
    },
    nome(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.carregarDados();
      }
    }
  },
};
</script>


<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/css/style.css';

html, body {
  overflow-x: hidden !important;
}

.btn-chat {
  position: absolute;
  right: 5px;
  z-index: 9999;
  width: 208px;
  height: 190px;
  border: none;
  background: url(/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/img/btn-chat.svg);
  background-repeat: no-repeat;
}

</style>
